export const en = {
  "REQUIRED_ACTION_KeepCapturing": "Keep Capturing",
  "REQUIRED_ACTION_PauseCapturing": "Pause Capturing",
  "REQUIRED_ACTION_Close": "Close",
  "REQUIRED_ACTION_Error": "Error",
  "REQUIRED_ACTION_AGREE": "Agree",
  "REQUIRED_ACTION_DISAGREE": "Disagree",
  "LIVENESS_ACTION_Smile": "Smile",
  "LIVENESS_ACTION_Frown": "Frown",
  "LIVENESS_ACTION_Tilt Left": "Look Left",
  "LIVENESS_ACTION_Tilt Right": "Look Right",
  "LIVENESS_ACTION_Tilt Up": "Look Up",
  "LIVENESS_ACTION_Tilt Down": "Look Down",
  "LIVENESS_ACTION_Look Straight": "Look Straight Ahead",
  "LIVENESS_ACTION_No Action": "No Action",
  "LIVENESS_ACTION_PROCESSING_LIVENESS": "Processing Liveness",
  "LIVENESS_RESULT_Thank you!.Failed": "Failed",
  "LIVENESS_RESULT_Thank you!.Passed": "Passed",
  "LIVENESS_RESULT_Thank you!.ActionTimedOut": "Action Timed Out",
  "LIVENESS_RESULT_Thank you!.Interrupted": "Interrupted",
  "LIVENESS_RESULT_Thank you!.Undefined": "Undefined",
  "LIVENESS_ACTION_LOOK_STRAIGHT_TITLE": "Look straight ahead",
  "LIVENESS_ACTION_LOOK_STRAIGHT_TEXT": "Keep your eyes on the screen at all times",
  "LIVENESS_ACTION_LOOK_LEFT_TITLE": "Rotate your head slightly to the left",
  "LIVENESS_ACTION_LOOK_LEFT_TEXT": "Keep your eyes on the screen at all times",
  "LIVENESS_ACTION_LOOK_RIGHT_TITLE": "Rotate your head slightly to the right",
  "LIVENESS_ACTION_LOOK_RIGHT_TEXT": "Keep your eyes on the screen at all times",
  "LIVENESS_ACTION_LOOK_UP_TITLE": "Rotate your head slightly upwards",
  "LIVENESS_ACTION_LOOK_UP_TEXT": "Keep your eyes on the screen at all times",
  "LIVENESS_ACTION_LOOK_DOWN_TITLE": "Rotate your head slightly downwards",
  "LIVENESS_ACTION_LOOK_DOWN_TEXT": "Keep your eyes on the screen at all times",
  "LIVENESS_ACTION_SMILE_TITLE": "Smile",
  "LIVENESS_ACTION_SMILE_TEXT": "Keep your eyes on the screen at all times",
  "LIVENESS_ACTION_FROWN_TITLE": "Frown",
  "LIVENESS_ACTION_FROWN_TEXT": "Keep your eyes on the screen at all times",
  "PASSIVE_LIVENESS_ERROR_FACE_TOO_CLOSE_TITLE": "Uh Oh...You are too close.",
  "PASSIVE_LIVENESS_ERROR_FACE_CLOSE_TO_BORDER_TITLE": "You are too close, please move further away so that your face fits within the provided frame. Please try again.",
  "PASSIVE_LIVENESS_ERROR_FACE_CROPPED_TITLE": "Something went wrong. Please try again.",
  "PASSIVE_LIVENESS_ERROR_FACE_CROPPED": "Something went wrong. Please try again.",
  "PASSIVE_LIVENESS_ERROR_FACE_NOT_FOUND_TITLE": "We are unable to detect a face within the image. Please try again.",
  "PASSIVE_LIVENESS_ERROR_FACE_TOO_SMALL_TITLE": "You are too far away, please move closer to the camera and make sure your face fits within the frame. Please try again.",
  "PASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE_TITLE": "Uh Oh...Something went wrong.",
  "ASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE": "Something went wrong. Please try again.",
  "PASSIVE_LIVENESS_ERROR_TOO_MANY_FACES": "We are unable to detect a face in the image. Please try again.",
  "PASSIVE_LIVENESS_ERROR_FACE_IS_OCCLUDED_TITLE": "It looks like your face is partly covered, please make sure that the whole of your face is in full view. Please try again.",
  "PASSIVE_LIVENESS_ERROR_UNKNOWN_TITLE": "Uh Oh...Something went wrong.",
  "PASSIVE_LIVENESS_ERROR_UNKNOWN": "Something went wrong. Please try again.",
  "PASSIVE_LIVENESS_ERROR_INTERNAL_TITLE": "Uh Oh...Something went wrong.",
  "PASSIVE_LIVENESS_ERROR_INTERNAL": "Something went wrong. Please try again.",
  "PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD_TITLE": "Uh Oh...Something went wrong.",
  "PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD": "Something went wrong. Please try again.",
  "PASSIVE_LIVENESS_ERROR_None_TITLE": "Uh Oh...Something went wrong.",
  "PASSIVE_LIVENESS_ERROR_None": "Something went wrong. Please try again.",
  "PASSIVE_LIVENESS_ERROR_FailedExpressions_TITLE": "Uh Oh...Something went wrong.",
  "PASSIVE_LIVENESS_ERROR_FailedExpressions": "Something went wrong. Please try again.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_IMAGE_TITLE": "Something went wrong. Please try again.",
  "PASSIVE_LIVENESS_ERROR_IMAGE_ERROR_TITLE": "Uh Oh...Something went wrong.",
  "PASSIVE_LIVENESS_ERROR_IMAGE_ERROR": "Something went wrong. Please try again.",
  "PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR_TITLE": "Uh Oh...Something went wrong.",
  "PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR": "Something went wrong. Please try again.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE_TITLE": "Uh Oh...Something went wrong.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE": "Something went wrong. Please try again.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL_TITLE": "Uh Oh...Something went wrong.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL": "Something went wrong. Please try again.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE_TITLE": "Uh Oh...Something went wrong.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE": "Something went wrong. Please try again.",
  "PASSIVE_LIVENESS_ERROR_INVALID_CONFIG_TITLE": "Uh Oh...Something went wrong.",
  "PASSIVE_LIVENESS_ERROR_INVALID_CONFIG": "Something went wrong. Please try again.",
  "PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD_TITLE": "Uh Oh...Something went wrong.",
  "PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD": "Something went wrong. Please try again.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT_TITLE": "Uh Oh...Something went wrong.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT": "Something went wrong. Please try again.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT_TITLE": "Uh Oh...Something went wrong.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT": "Something went wrong. Please try again.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS_TITLE": "Uh Oh...Something went wrong.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS": "Something went wrong. Please try again.",
  "PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE_TITLE": "Uh Oh...Something went wrong.",
  "PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE": "Something went wrong. Please try again.",
  "PASSIVE_LIVENESS_ERROR_NULLPTR_TITLE": "Uh Oh...Something went wrong.",
  "PASSIVE_LIVENESS_ERROR_NULLPTR": "Something went wrong. Please try again.",
  "PASSIVE_LIVENESS_ERROR_LICENSE_ERROR_TITLE": "Uh Oh...Something went wrong.",
  "PASSIVE_LIVENESS_ERROR_LICENSE_ERROR": "Something went wrong. Please try again.",
  "PASSIVE_LIVENESS_ERROR_INVALID_META_TITLE": "Uh Oh...Something went wrong.",
  "PASSIVE_LIVENESS_ERROR_INVALID_META": "Something went wrong. Please try again.",
  "INITIALIZING_TITLE": "Initializing",
  "INITIALIZING_DESCRIPTION": "Checking hardware capabilities, please wait…",
  "JOURNEY_STATE_STARTED": "Started",
  "JOURNEY_STATE_INPROGRESS": "In Progress",
  "JOURNEY_STATE_ENDED": "Ended",
  "INFO_JOURNEY_STATE": "State",
  "INFO_JOURNEY_ACTION": "Action",
  "INFO_JOURNEY_ACTION_ATTEMPT": "Action Attempt",
  "INFO_JOURNEY_ID": "Journey ID",
  "INFO_JOURNEY_RESULT": "Result",
  "RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE": "Result Message",
  "INFO_JOURNEY_REFERENCE": "Reference",
  "FLOW_STATE_NONE": "None",
  "FLOW_STATE_IDENTITY:FRONT": "Front Side",
  "FLOW_STATE_IDENTITY:BACK": "Back Side",
  "FLOW_STATE_ADDRESS": "Address",
  "FLOW_STATE_SELFIE": "Selfie",
  "FLOW_STATE_LIVENESS": "Liveness",
  "FLOW_STATE_COVID": "Covid",
  "PROVIDER_TITLE_CAMERA": "Camera",
  "PROVIDER_TITLE_CROPPER": "Cropper",
  "PROVIDER_TITLE_FILESYSTEM_ID": "Upload a photo of your Identity Document",
  "PROVIDER_TITLE_FILESYSTEM_FACEMATCH": "Upload a photo of yourself",
  "PROVIDER_TITLE_FILESYSTEM_ADDRESS": "Upload a photo of your Proof of Address",
  "PROVIDER_TITLE_FILESYSTEM_COVID": "Upload a photo of your Covid Document",
  "PROVIDER_TITLE_GATEWAY": "Gateway",
  "PROVIDER_TITLE_LIVENESS": "Liveness",
  "PROVIDER_TITLE_LOGIN": "Login",
  "PROVIDER_TITLE_RESULTS": "Results",
  "PROVIDER_TITLE_SCANNER": "Scan your Identity Document",
  "PROVIDER_TITLE_VIEW_ID": "Check the preview of your Identity Document",
  "PROVIDER_TITLE_VIEW_FACEMATCH": "Check the preview of your selfie",
  "PROVIDER_TITLE_VIEW_ADDRESS": "Check the preview of your Proof of Address",
  "PROVIDER_TITLE_VIEW_COVID": "Check the preview of your Covid",
  "PROVIDER_SUBTITLE_FILESYSTEM_ID": "Please upload a photo of your Identity Document that is clear, in focus, not covered and directly face on.",
  "PROVIDER_SUBTITLE_FILESYSTEM_FACEMATCH": "Please upload a photo of yourself that is clear, in focus, not covered and directly face on",
  "PROVIDER_SUBTITLE_FILESYSTEM_ADDRESS": "Please upload a photo of your document that is clear, in focus, not covered and directly face on.",
  "PROVIDER_SUBTITLE_FILESYSTEM_COVID": "Please upload a photo of your document that is clear, in focus, not covered and directly face on.",
  "PROVIDER_SUBTITLE_SCANNER_ID": "Place the photo page of your Identity Document face down onto the scanner.",
  "PROVIDER_SUBTITLE_VIEW_ID": "Please check the preview of your document is clear, in focus, not covered and directly face on.",
  "PROVIDER_SUBTITLE_VIEW_FACEMATCH": "Please check the preview of your selfie is clear, in focus, not covered and directly face on.",
  "PROVIDER_SUBTITLE_VIEW_ADDRESS": "Please check the preview of your document is clear, in focus, not covered and directly face on.",
  "PROVIDER_SUBTITLE_VIEW_COVID": "Please check the preview of your document is clear, in focus, not covered and directly face on.",
  "PROVIDER_TITLE_SMART_CAPTURE": "Smart Capture",
  "PROVIDER_TITLE_JOURNEY_SELECT": "Select Journey",
  "PROVIDER_TITLE_TERMS_AND_CONDITIONS": "Terms and Conditions",
  "PROVIDER_TITLE_USER_INPUT": "Please complete the following form",
  "FILESYSTEM_SUPPORTED_TYPES_FIRST": "Accepted formats:",
  "FILESYSTEM_SUPPORTED_TYPES_LIST": "JPG, PNG, PDF",
  "FILESYSTEM_SUPPORTED_TYPES_PDF": "PDF",
  "FILESYSTEM_SUPPORTED_TYPES_SECOND": "(in case of",
  "FILESYSTEM_SUPPORTED_TYPES_THIRD": "only the first page will be processed)",
  "FILESYSTEM_SUPPORTED_TYPES_START_SELFIE": "Accepted formats: JPG, PNG",
  "FILESYSTEM_MAX_FILE_SIZE": "File size: we accept any file size smaller than",
  "FILESYSTEM_MAX_FILE_SIZE_NUMBER": "7,5 MB",
  "FILESYSTEM_CHECK_FILE_TOO_BIG": "Your file is too big. Please upload a file that is smaller than 7.5MB.",
  "FILESYSTEM_CHECK_FILE_INCORRECT_FORMAT": "Your file is the incorrect format. Please upload one of the accepted formats.",
  "FILESYSTEM_IDENTITY_DOCUMENT": "Identity Document",
  "FILESYSTEM_FACEMATCH": "Face Match",
  "FILESYSTEM_ADDRESS": "Proof of Address",
  "FILESYSTEM_COVID": "Covid",
  "FILESYSTEM_DRAG_DROP": "Drag and Drop",
  "FILESYSTEM_OR": "or",
  "FILESYSTEM_CHOOSE": "Choose a file",
  "FILESYSTEM_UPLOADING": "Uploading...",
  "TRIPLESCAN_GUIDANCE_TRYAGAIN": "Try again",
  "FAILURE_REASON_REFER": "Your Identity Document failed the validation.",
  "FAILURE_REASON_EXPIRED": "Your Identity Document is expired.",
  "FAILURE_REASON_NOT_ACCEPTED": "Your Identity Document is not an accepted document type.",
  "FAILURE_REASON_NOT_SUPPORTED": "Your Identity Document could not be classified or is not supported.",
  "PLEASE_TRY_AGAIN_REFER": "Please try again.",
  "PLEASE_TRY_AGAIN_EXPIRED": "Please try again with a valid document.",
  "PLEASE_TRY_AGAIN_NOT_ACCEPTED": "Please try again with a different document.",
  "PLEASE_TRY_AGAIN_NOT_SUPPORTED": "Please try again.",
  "BLUR_CHECK_REASON": "Blur - the document is unclear;",
  "GLARE_CHECK_REASON": "Glare - the document is unreadable due to a bright light source;",
  "RESOLUTION_CHECK_REASON": "Low Resolution - the document does not fill the frame properly;",
  "EDGES_CHECK_REASON": "Missing Edges - the document is not positioned in the frame properly;",
  "VALIDATION_FAILED": "Validation failed",
  "VALIDATION_FAILED_REASON_DOC_UNKNOWN": "- document unknown.",
  "VALIDATION_FAILED_REASON_DOC_NOT_ACCEPTED": "- document not accepted.",
  "VALIDATION_FAILED_REASON_DOC_EXPIRED": "- document expired.",
  "PREVIEW_INFO_TITLE_ID": "Examples of good and bad photos",
  "PREVIEW_INFO_GOOD": "Good",
  "PREVIEW_INFO_BAD": "Bad",
  "PREVIEW_INFO_GOOD_EXAMPLE_ID": "Photo is clear, in focus, and directly face on.",
  "PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ID": "Photo must show all four corners.",
  "PREVIEW_INFO_BAD_EXAMPLE_COVER_ID": "Document must not be covered.",
  "PREVIEW_INFO_BAD_EXAMPLE_BLUR_ID": "Photo must not be blurry.",
  "PREVIEW_INFO_TITLE_FACEMATCH": "Tips for a good quality selfie",
  "PREVIEW_INFO_GOOD_EXAMPLE_FACEMATCH": "Selfie is clear, in focus, and directly face on.",
  "PREVIEW_INFO_BAD_EXAMPLE_ANGLE_FACEMATCH": "Selfie must show the full face.",
  "PREVIEW_INFO_BAD_EXAMPLE_COVER_FACEMATCH": "Face must not be covered.",
  "PREVIEW_INFO_BAD_EXAMPLE_BLUR_FACEMATCH": "Selfie must not be blurry.",
  "PREVIEW_INFO_TITLE_ADDRESS": "Tips for a good quality photo",
  "PREVIEW_INFO_GOOD_EXAMPLE_ADDRESS": "Photo is clear, in focus, and directly face on.",
  "PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ADDRESS": "Photo must show all four corners.",
  "PREVIEW_INFO_BAD_EXAMPLE_COVER_ADDRESS": "Document must not be covered.",
  "PREVIEW_INFO_BAD_EXAMPLE_BLUR_ADDRESS": "Photo must not be blurry.",
  "PREVIEW_INFO_TITLE_COVID": "Tips for a good quality photo",
  "PREVIEW_INFO_GOOD_EXAMPLE_COVID": "Photo is clear, in focus, and directly face on.",
  "PREVIEW_INFO_BAD_EXAMPLE_ANGLE_COVID": "Photo must show all four corners.",
  "PREVIEW_INFO_BAD_EXAMPLE_COVER_COVID": "Document must not be covered.",
  "PREVIEW_INFO_BAD_EXAMPLE_BLUR_COVID": "Photo must not be blurry.",
  "ATTEMPTS_REMAINING": "Number of remaining attempts:",
  "CAMERA_CAPTURE": "Turn on camera",
  "CAMERA_CAPTURE_START_BUTTON": "Start Auto Capture",
  "CAMERA_CAPTURE_CAPTION": "Click on Start Auto Capture to begin",
  "CAMERA_PREVIEW_START": "Turn on your camera to start Auto Capture",
  "CAMERA_CONDITION_BLUR": "Blur Detected",
  "CAMERA_CONDITION_CAPTURING": "Capturing",
  "CAMERA_CONDITION_UPLOADING": "Uploading...Please wait",
  "CAMERA_CONDITION_ALIGNMENT": "Document not in frame",
  "CAMERA_CONDITION_GLARE": "Glare Detected",
  "VERIFYING_TITLE": "Verifying ...",
  "PREPARING_PREVIEW_TITLE": "Preparing preview ...",
  "CAMERA_CONDITION_LOW_RESOLUTION": "Document Too Far",
  "CAMERA_LOADING": "Opening Camera...",
  "CAMERA_SMARTCAPTURE_ON": "AUTO CAPTURE - ON",
  "CAMERA_SMARTCAPTURE_OFF": "AUTO CAPTURE - OFF",
  "CAMERA_CAPTURE_FRONT": "Position the photo side of your Identity Document within the frame below.",
  "CAMERA_MANUAL_CAPTURE_FRONT": "Position your Identity Document within the frame and click on the button below",
  "CAMERA_CAPTURE_BACK": "Position the BACK of your Identity Document within the frame",
  "CAMERA_CAPTURE_SELFIE_CAPTION": "Position your face within the oval, look directly into the camera and click on the button below to take a selfie.",
  "CAMERA_CAPTURE_ADDRESS_CAPTION": "Position your Proof of Address within the frame and click on the button below to take a photo.",
  "CAMERA_CAPTURE_COVID_CAPTION": "Position your Covid document within the frame and click on the button below to take a photo.",
  "CAMERA_PREVENT_GLARE_HINT": "Move the document away from direct light sources.",
  "CAMERA_PREVENT_BLUR_HINT": "Hold the document or device steady.",
  "CAMERA_PREVENT_LOW_RES_HINT": "Fit the document fully within the frame.",
  "CROPPER_RETRY": "Retry",
  "CROPPER_UPLOAD": "Upload",
  "CROPPER_UPLOADING": "Uploading...",
  "FILESYSTEM_SELECT": "Select",
  "FILESYSTEM_DROP_IMAGE": "or Drop Image",
  "GATEWAY_CAMERA": "Camera Enabled",
  "GATEWAY_CANCEL": "Cancel Journey",
  "LIVENESS_START": "Start Liveness",
  "PASSIVE_LIVENESS_START": "Take Picture",
  "LOGIN_USERNAME": "Username",
  "LOGIN_PASSWORD": "Password",
  "LOGIN_SUBMIT": "Submit",
  "RESULTS_DOCUMENTS": "Documents",
  "RESULTS_DOCUMENTS_NONE": "None Found",
  "RESULTS_DOCUMENT_TYPE": "Document Type",
  "RESULTS_DOCUMENT_RESULT": "Document Result",
  "RESULTS_EXTRACTED_FIELDS_NONE": "Result Details",
  "RESULTS_DETAILS_NONE": "None Found",
  "RESULTS_NEW_JOURNEY": "Start New Journey",
  "RESULTS_NO_INFORMATION": "There is no information for this journey",
  "RESULTS_LOGOUT": "Logout",
  "RESULTS_HIGH_LEVEL_Aborted": "Aborted",
  "RESULTS_HIGH_LEVEL_TCCDISAGREE": "Aborted T&C's",
  "RESULTS_HIGH_LEVEL_Expired": "Expired",
  "RESULTS_HIGH_LEVEL_NotAccepted": "Not Accepted",
  "RESULTS_HIGH_LEVEL_NotSupported": "Not Supported",
  "RESULTS_HIGH_LEVEL_Notsupported": "Not Supported",
  "RESULTS_HIGH_LEVEL_Passed": "Passed",
  "RESULTS_HIGH_LEVEL_Refer": "Refer",
  "RESULTS_HIGH_LEVEL_Undefined": "Undefined",
  "RESULTS_HIGH_LEVEL_DETAIL_ACCUMULATIVELIVENESSRESULT": "Accumulative Liveness Result",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTFRONTSIDETYPECHECK": "Document Front Side Type Check",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBACKSIDECHECK": "Document Back Side Check",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBLOCKINGPOLICY": "Document Blocking Policy",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTEXPIRY": "Document Expiry",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTSUPPORT": "Document Support",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTVALIDATION": "Document Validation",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTPROOFPOLICY": "Document Proof Policy",
  "RESULTS_HIGH_LEVEL_DETAIL_FACEMATCHVALIDATION": "Facematch Validation",
  "RESULTS_HIGH_LEVEL_DETAIL_UNDERAGERULE": "Underage Rule",
  "RESULTS_HIGH_LEVEL_DETAIL_VALUE_SUCCESS_NEEDED": "Success Needed",
  "RESULTS_HIGH_LEVEL_DETAIL_COVID_PASS_CROSSCHECK": "Covid Pass Cross Check",
  "RESULTS_HIGH_LEVEL_DETAIL_DATA_CHECK": "Data Checks",
  "RESULTS_HIGH_LEVEL_DETAIL_VALUE_FAILED": "Failed",
  "RESULTS_HIGH_LEVEL_DETAIL_VALUE_NOTNEEDED": "Not Needed",
  "RESULTS_HIGH_LEVEL_DETAIL_VALUE_PASSED": "Passed",
  "RESULTS_HIGH_LEVEL_DETAIL_VALUE_SKIPPED": "Skipped",
  "RESULTS_HIGH_LEVEL_DETAIL_VALUE_UNDETERMINED": "Undetermined",
  "ADDITIONAL_CHECKS_DETAILS": "Additional Checks",
  "ADDITIONAL_CHECKS_DETAILS_NONE": "None Found",
  "ADDITIONAL_CHECKS_DETAIL_DATACHECKS": "Data Checks",
  "ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK": "Lookback Checks",
  "ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK_NA": "N/A",
  "GBG_SCORES": "GBG Scores",
  "GBG_TRUST_SCORE": "GBG Trust Score",
  "GBG_SCORE": "GBG Score",
  "VIEW_RETRY": "Change photo",
  "VIEW_CROP": "Crop",
  "VIEW_CROPPING": "Cropping…",
  "VIEW_UPLOAD": "Upload",
  "VIEW_UPLOADING": "Uploading…",
  "SMART_CAPTURE_INITIALIZING": "Start",
  "SMART_CAPTURE_START": "Initialising Smart Capture, Please Wait…",
  "SCANNER_DESC_AVAILABLE": "The scanner is available. Place your document in the scanner.",
  "SCANNER_DESC_PROCESSING": "The image is being processed by the server.",
  "SCANNER_DESC_SCANNING": "The image is being scanned by the device.",
  "SCANNER_DESC_DISCONNECTED": "The scanner is disconnected from the network.",
  "SCANNER_DESC_NOT_CONNECTED": "The scanner is not connected.",
  "SCANNER_DESC_OFFLINE": "The scanner is offline.",
  "SCANNER_DESC_BUSY": "The scanner is used by another user in your local network.",
  "SCANNER_DESC_WAITING": "Waiting for the connection to be established.",
  "SCANNER_DESC_LOADING": "Please Wait…",
  "SCANNER_TITLE_SCANNING": "Scanning...",
  "SCANNER_TITLE_DISCONNECTED": "DISCONNECTED",
  "SCANNER_TITLE_NOT_CONNECTED": "NOT CONNECTED",
  "SCANNER_TITLE_OFFLINE": "Scanner offline",
  "SCANNER_TITLE_BUSY": "Scanner Busy",
  "SCANNER_TITLE_WAITING": "WAITING",
  "SCANNER_ACTION_REGISTER": "Register",
  "SCANNER_ACTION_RELEASE": "Release",
  "CANCEL_JOURNEY": "Cancel",
  "MANUAL_PHOTO_UPLOAD_TOGGLE_FALSE": "Upload a photo instead",
  "MANUAL_PHOTO_UPLOAD_TOGGLE_TRUE": "Take a photo instead",
  "JOURNEY_SELECT_CONTINUE": "Continue",
  "HELP_MODAL_AUTOCAPTURE_TITLE": "How to take a photo of your Identity Document",
  "HELP_MODAL_AUTOCAPTURE_SUBTITLE": "When Auto Capture is on, the capture screen will automatically take a photo of your document when it has recognised that it is of good enough quality.",
  "HELP_MODAL_AUTOCAPTURE_TIPS": "Tips for taking a good quality photo",
  "HELP_MODAL_AUTOCAPTURE_GLARE_TITLE": "Prevent Glare",
  "HELP_MODAL_AUTOCAPTURE_GLARE_SUBTITLE": "Move the document away from direct light sources.",
  "HELP_MODAL_AUTOCAPTURE_FAR_TITLE": "Document Too Far",
  "AUTOCAPTURE_FAR_SUBTITLE": "Fit the document fully within the frame.",
  "AUTOCAPTURE_BLUR_TITLE": "Prevent Blur",
  "HELP_MODAL_AUTOCAPTURE_BLUR_SUBTITLE": "Hold the document or device steady.",
  "HELP_MODAL_AUTOCAPTURE_MANUAL_CAPTURE": "Still struggling? Take a photo with Manual Capture",
  "HELP_MODAL_AUTOCAPTURE_TURN_MANUAL_CAPTURE": "Manual Capture",
  "HELP_MODAL_SELFIE_TITLE": "How to take a selfie",
  "HELP_MODAL_SELFIE_SUBTITLE": "Look directly into the camera and click on the manual capture button.",
  "HELP_MODAL_POA_TITLE": "How to take a photo of your Proof of Address",
  "HELP_MODAL_POA_SUBTITLE": "Position your document within the frame and click on the capture button to take a photo of your document.",
  "HELP_MODAL_POA_TIPS": "Tips for taking a good quality photo",
  "HELP_MODAL_POA_GLARE_TITLE": "Prevent Glare",
  "HELP_MODAL_POA_GLARE_SUBTITLE": "Move the document away from direct light sources.",
  "HELP_MODAL_POA_FAR_TITLE": "Document Too Far",
  "HELP_MODAL_POA_FAR_SUBTITLE": "Fit the document fully within the frame.",
  "HELP_MODAL_POA_BLUR_TITLE": "Prevent Blur",
  "HELP_MODAL_POA_BLUR_SUBTITLE": "Hold the document or device steady.",
  "HELP_MODAL_POA_MANUAL_CAPTURE": "Still struggling? Turn on Manual Capture",
  "HELP_MODAL_POA_TURN_MANUAL_CAPTURE": "Manual Capture",
  "HELP_MODAL_COVID_TITLE": "How to take a photo of your Covid document",
  "HELP_MODAL_COVID_SUBTITLE": "Position your document within the frame and click on the capture button to take a photo of your document.",
  "HELP_MODAL_COVID_TIPS": "Tips for taking a good quality photo",
  "HELP_MODAL_COVID_GLARE_TITLE": "Prevent Glare",
  "HELP_MODAL_COVID_GLARE_SUBTITLE": "Move the document away from direct light sources.",
  "HELP_MODAL_COVID_FAR_TITLE": "Document Too Far",
  "HELP_MODAL_COVID_FAR_SUBTITLE": "Fit the document fully within the frame.",
  "HELP_MODAL_COVID_BLUR_TITLE": "Prevent Blur",
  "HELP_MODAL_COVID_BLUR_SUBTITLE": "Hold the document or device steady.",
  "HELP_MODAL_COVID_MANUAL_CAPTURE": "Still struggling? Turn on Manual Capture",
  "HELP_MODAL_COVID_TURN_MANUAL_CAPTURE": "Manual Capture",
  "HELP_MODAL_NEED_HELP": "Need help?",
  "EXCEPTION": "An unexpected exception has occurred",
  "EXCEPTION_AUTHORIZATION": "Unauthorized",
  "EXCEPTION_AUTHORIZATION_ACCOUNT_NOT_AUTHORIZED": "Your account is not authorized to access this resource",
  "EXCEPTION_AUTHORIZATION_AUTH_DETAILS_INVALID": "Username and Password combination is not valid",
  "EXCEPTION_AUTHORIZATION_AUTH_NOT_ENABLED": "You must enable auth to use this functionality",
  "EXCEPTION_AUTHORIZATION_PROCESS_NOT_AUTHORIZED": "You are not authorized for this process",
  "EXCEPTION_BAD_REQUEST": "Bad Request with status code 400",
  "EXCEPTION_BAD_REQUEST_INVALID_IMAGE": "Not a valid image",
  "EXCEPTION_BAD_REQUEST_WAITING_FOR_RESPONSE": "The journey is waiting for a response",
  "EXCEPTION_FLOW_STATE_JOURNEY_ENDED": "Cannot send requests. The journey has ended",
  "EXCEPTION_FLOW_STATE_MISSING": "Flow state not found",
  "EXCEPTION_INVALID_PARAMETER_CALLBACK_MUST_BE_FUNCTION": "Callback must be a valid function",
  "EXCEPTION_INVALID_PARAMETER_NAME_MUST_BE_STRING": "Event name must be a string value",
  "EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_NUMBER": "Priority must be a number",
  "EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_POSITIVE_NUMBER": "Priority must be a positive number",
  "EXCEPTION_INVALID_PARAMETER_SHOULD_BE_ELEMENT_OR_SELECTOR": "Container should either be an element or selector",
  "EXCEPTION_INVALID_PARAMETER_VALUE_NOT_VALID": "Value is not valid",
  "EXCEPTION_INVALID_PARAMETER_VALUE_DAMAGED": "Value has been damaged",
  "EXCEPTION_MISSING_PARAMETER_BACKEND_URL_MISSING": "Configuration should include a backendUrl parameter",
  "EXCEPTION_MISSING_PARAMETER_COORDINATES_MISSING": "Supplied parameters must contain coordinates",
  "EXCEPTION_MISSING_PARAMETER_IMAGES_MISSING": "Supplied parameters must contain images",
  "EXCEPTION_MISSING_PARAMETER_PASSWORD_MISSING": "Supplied parameters should contain password",
  "EXCEPTION_MISSING_PARAMETER_USERNAME_MISSING": "Supplied parameters should contain username",
  "EXCEPTION_MISSING_REQUIRED_FIELD_MISSING": "Please fill the all required fields",
  "EXCEPTION_POSTCODE_FORMAT_ERROR": "Postal code format is not valid minLength:5 / maxLength:8",
  "EXCEPTION_HOUSENUMBER_FORMAT_ERROR": "House Name/Number format is not valid minLength:1 / maxLength:20",
  "EXCEPTION_STREETNAME_FORMAT_ERROR": "Street Name is not valid minLength:1 / maxLength:30",
  "EXCEPTION_TOWN_FORMAT_ERROR": "Town format is not valid minLength:1 / maxLength:20",
  "EXCEPTION_JOURNEY_DEFINITIONS_MISSING": "No journey definitions are available for this channel",
  "EXCEPTION_NETWORK": "A network exception has occurred, please check your connection and try again",
  "EXCEPTION_PLATFORM_BROWSER_ONLY": "This feature can only be used in browser",
  "EXCEPTION_PLATFORM_UNSUPPORTED": "Your environment does not support this feature",
  "EXCEPTION_PLATFORM_CAMERA_PERMISSION_DENIED": "Camera permissions have not been granted, please check your browser settings",
  "EXCEPTION_PLATFORM_CAMERA_PERMISSION_UNAVAILABLE": "Camera permissions are unavailable",
  "EXCEPTION_PLATFORM_CAMERA_NOT_READABLE": "The camera could not be accessed. Please close any other applications and try again",
  "EXCEPTION_PLATFORM_CAMERA_NONE_SUITABLE": "No suitable cameras have been found on your device",
  "EXCEPTION_SERVER": "Request failed with status code 500",
  "EXCEPTION_SERVER_UNREACHABLE": "Request failed, Server Unreachable",
  "EXCEPTION_SERVER_DATA_NOT_PERSISTED": "An error occurred during the process. Your data may not be persisted",
  "EXCEPTION_SERVER_RESULT_NOT_PASSING": "Current result not passing",
  "EXCEPTION_TEMPLATE_CANVAS_CONTEXT_UNAVAILABLE": "Canvas context not available",
  "EXCEPTION_TEMPLATE_CONTAINER_MISSING": "Container is not present",
  "EXCEPTION_TEMPLATE_ELEMENTS_MISSING": "Required elements missing",
  "EXCEPTION_TEMPLATE_MISSING": "Template not found",
  "EXCEPTION_TEMPLATE_SOURCE_ELEMENT_MISSING": "Unable to find source element",
  "EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_CANNOT_RETRIEVE": "Cannot get input providers",
  "EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NONE_SPECIFIED": "No input providers specified",
  "EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NOT_AVAILABLE": "Input provider is not available",
  "SUPPORTED_DOCUMENT_Account Statement": "Account Statement",
  "SUPPORTED_DOCUMENT_Agreement (Tenancy)": "Agreement (Tenancy)",
  "SUPPORTED_DOCUMENT_Bank Document": "Bank Document",
  "SUPPORTED_DOCUMENT_Bank Letter": "Bank Letter",
  "SUPPORTED_DOCUMENT_Bank Statement": "Bank Statement",
  "SUPPORTED_DOCUMENT_Benefit Letter": "Benefit Letter",
  "SUPPORTED_DOCUMENT_Certificate (Birth, Marriage, Civil partnership)": "Certificate (Birth, Marriage, Civil partnership)",
  "SUPPORTED_DOCUMENT_Council Document": "Council Document",
  "SUPPORTED_DOCUMENT_Council Letter": "Council Letter",
  "SUPPORTED_DOCUMENT_Council Tax": "Council Tax",
  "SUPPORTED_DOCUMENT_Driving License": "Driving License",
  "SUPPORTED_DOCUMENT_Driving Licence": "Driving Licence",
  "SUPPORTED_DOCUMENT_DWP Document": "DWP Document",
  "SUPPORTED_DOCUMENT_HMRC Document": "HMRC Document",
  "SUPPORTED_DOCUMENT_Information Sheet": "Information Sheet",
  "SUPPORTED_DOCUMENT_Insurance Document": "Insurance Document",
  "SUPPORTED_DOCUMENT_Insurance Letter": "Insurance Letter",
  "SUPPORTED_DOCUMENT_Invoice": "Invoice",
  "SUPPORTED_DOCUMENT_NIC Letter": "NIC Letter",
  "SUPPORTED_DOCUMENT_NINO Letter": "NINO Letter",
  "SUPPORTED_DOCUMENT_Official Document": "Official Document",
  "SUPPORTED_DOCUMENT_Official Letter": "Official Letter",
  "SUPPORTED_DOCUMENT_Repayment Letter (related to Tax or Social support)": "Repayment Letter (related to Tax or Social support)",
  "SUPPORTED_DOCUMENT_Tax Letter": "Tax Letter",
  "SUPPORTED_DOCUMENT_Tax Statement": "Tax Statement",
  "SUPPORTED_DOCUMENT_Tel Bill": "Tel Bill",
  "SUPPORTED_DOCUMENT_Tel Letter": "Tel Letter",
  "SUPPORTED_DOCUMENT_Telecommunication Document": "Telecommunication Document",
  "SUPPORTED_DOCUMENT_TV Licence": "TV Licence",
  "SUPPORTED_DOCUMENT_University Letter": "University Letter",
  "SUPPORTED_DOCUMENT_Utility Bill": "Utility Bill",
  "SUPPORTED_DOCUMENT_Utility Document": "Utility Document",
  "SUPPORTED_DOCUMENT_Utility Letter": "Utility Letter",
  "SUPPORTED_DOCUMENT_Water Bil": "Water Bil",
  "SUPPORTED_DOCUMENT_Water Document": "Water Document",
  "SUPPORTED_DOCUMENT_Agents License": "Agents License",
  "SUPPORTED_DOCUMENT_Electoral Card": "Electoral Card",
  "SUPPORTED_DOCUMENT_Foreigner Identification Card": "Foreigner Identification Card",
  "SUPPORTED_DOCUMENT_Health Card": "Health Card",
  "SUPPORTED_DOCUMENT_Job License": "Job License",
  "SUPPORTED_DOCUMENT_Membership Identification Card": "Membership Identification Card",
  "SUPPORTED_DOCUMENT_Military Identification Card": "Military Identification Card",
  "SUPPORTED_DOCUMENT_National Identification Card": "National Identification Card",
  "SUPPORTED_DOCUMENT_Passport": "Passport",
  "SUPPORTED_DOCUMENT_Travel Permit": "Travel Permit",
  "SUPPORTED_DOCUMENT_Visa": "Visa",
  "SUPPORTED_DOCUMENT_Weapons Licence": "Weapons Licence",
  "SUPPORTED_DOCUMENT_Selfie Photo": "Selfie Photo",
  "SUPPORTED_DOCUMENT_Unknown": "Unknown",
  "SUPPORTED_DOCUMENT_COVIDPAS": "Covid Pass",
  "EXTRACTED_FIELDS_AddressFull": "Address Full",
  "EXTRACTED_FIELDS_AddressCity": "Address City",
  "EXTRACTED_FIELDS_AddressPostCode": "Address Post Code",
  "EXTRACTED_FIELDS_LastNameFirstPart": "Last Name First Part",
  "EXTRACTED_FIELDS_Sex": "Sex",
  "EXTRACTED_FIELDS_BirthPlace": "Birth Place",
  "EXTRACTED_FIELDS_IssueNumber": "Issue Number",
  "EXTRACTED_FIELDS_DocumentNumberCheckDigit": "Document Number Check Digit",
  "EXTRACTED_FIELDS_BirthDate": "Birth Date",
  "EXTRACTED_FIELDS_DocumentNumber": "Document Number",
  "EXTRACTED_FIELDS_FirstName": "First Name",
  "EXTRACTED_FIELDS_ArbitraryDigit": "Arbitrary Digit",
  "EXTRACTED_FIELDS_FirstNameInitial": "First Name Initial",
  "EXTRACTED_FIELDS_ExpiryDate": "Expiry Date",
  "EXTRACTED_FIELDS_IssueDate": "Issue Date",
  "EXTRACTED_FIELDS_LastName": "Last Name",
  "EXTRACTED_FIELDS_LicenseCategory": "License Category",
  "EXTRACTED_FIELDS_DocumentCategory": "Document Category",
  "EXTRACTED_FIELDS_DocumentType": "Document Type",
  "EXTRACTED_FIELDS_NationalityCode": "Nationality Code",
  "EXTRACTED_FIELDS_MiddleName": "Middle Name",
  "EXTRACTED_FIELDS_FirstIssuanceDate": "First Issue Date",
  "EXTRACTED_FIELDS_SecondLastName": "Second Last Name",
  "EXTRACTED_FIELDS_FullName": "Full Name",
  "EXTRACTED_FIELDS_PersonalNumber": "Personal Number",
  "EXTRACTED_FIELDS_NationalityName": "Nationality",
  "EXTRACTED_FIELDS_BarcodeItems": "BarcodeS",
  "EXTRACTED_FIELDS_BirthPlaceCity": "City of Birth",
  "EXTRACTED_FIELDS_BirthPlaceState": "State of Birth",
  "EXTRACTED_FIELDS_BirthPlaceCountry": "Country of Birth",
  "EXTRACTED_FIELDS_MRZFull": "Full MRZ",
  "EXTRACTED_FIELDS_MRZLine1": "MRZ Line 1",
  "EXTRACTED_FIELDS_MRZLine2": "MRZ Line 2",
  "EXTRACTED_FIELDS_MRZLine3": "MRZ Line 3",
  "EXTRACTED_FIELDS_ObservationPage": "Observation Page",
  "EXTRACTED_FIELDS_IssuingAuthority": "Issuing Authority",
  "EXTRACTED_FIELDS_IssuingLocation": "Issuing Location",
  "EXTRACTED_FIELDS_MaritalStatus": "Marital Status",
  "EXTRACTED_FIELDS_Occupation": "Occupation",
  "EXTRACTED_FIELDS_AlienNumber": "Alien Number",
  "EXTRACTED_FIELDS_Employer": "Employer",
  "EXTRACTED_FIELDS_AddressLine1": "Address Line 1",
  "EXTRACTED_FIELDS_AddressLine2": "Address Line 2",
  "EXTRACTED_FIELDS_AddressLine3": "Address Line 3",
  "EXTRACTED_FIELDS_AddressLine4": "Address Line 4",
  "EXTRACTED_FIELDS_AddressState": "State",
  "EXTRACTED_FIELDS_AddressDistrict": "District",
  "EXTRACTED_FIELDS_AddressBuildingNumber": "Building Number",
  "EXTRACTED_FIELDS_AddressBuildingName": "Building Name",
  "EXTRACTED_FIELDS_AddressStreet": "Street",
  "EXTRACTED_FIELDS_AddressCountry": "Country",
  "EXTRACTED_FIELDS_RefAddressFull": "Reference Address",
  "EXTRACTED_FIELDS_RefAddressLine1": "Reference Address Line 1",
  "EXTRACTED_FIELDS_RefAddressLine2": "Reference Address Line 2",
  "EXTRACTED_FIELDS_RefAddressLine3": "Reference Address Line 3",
  "EXTRACTED_FIELDS_RefAddressLine4": "Reference Address Line 4",
  "EXTRACTED_FIELDS_RefAddressCity": "Reference Address City",
  "EXTRACTED_FIELDS_RefAddressState": "Reference Address State",
  "EXTRACTED_FIELDS_RefAddressDistrict": "Reference Address District",
  "EXTRACTED_FIELDS_RefAddressBuildingNumber": "Reference Address Building Number",
  "EXTRACTED_FIELDS_RefAddressBuildingName": "Reference Address Building Name",
  "EXTRACTED_FIELDS_RefAddressSubBuildingName": "Reference Address Sub Building Name",
  "EXTRACTED_FIELDS_RefAddressStreet": "Reference Address Street",
  "EXTRACTED_FIELDS_RefAddressCountry": "Reference Address Country",
  "EXTRACTED_FIELDS_RefAddressPostCode": "Reference Address Postcode",
  "EXTRACTED_FIELDS_HealthNumber": "Health Number",
  "EXTRACTED_FIELDS_Endorsements": "Endorsements",
  "EXTRACTED_FIELDS_Constraints": "Constraints",
  "EXTRACTED_FIELDS_LicenseMarine": "License Marine",
  "EXTRACTED_FIELDS_Height": "Height",
  "EXTRACTED_FIELDS_Weight": "Weight",
  "EXTRACTED_FIELDS_HairColor": "Hair Colour",
  "EXTRACTED_FIELDS_EyeColor": "Eye Colour",
  "EXTRACTED_FIELDS_LensData": "Eyesight",
  "EXTRACTED_FIELDS_SocialSecurityNumber": "Social Security Number",
  "EXTRACTED_FIELDS_NationalInsuranceNumber": "National Insurance Number",
  "EXTRACTED_FIELDS_Race": "Race",
  "EXTRACTED_FIELDS_MotherName": "Mother’s Name",
  "EXTRACTED_FIELDS_FatherName": "Father’s Name",
  "EXTRACTED_FIELDS_Parents": "Parents",
  "EXTRACTED_FIELDS_Remarks": "Remarks",
  "EXTRACTED_FIELDS_DistinguishingMarks": "Distinguishing Marks",
  "EXTRACTED_FIELDS_PeriodOfStay": "Period Of Stay",
  "EXTRACTED_FIELDS_TaxNumber": "Tax Number",
  "EXTRACTED_FIELDS_Donor": "Donor",
  "EXTRACTED_FIELDS_RFIDG1": "RFID Raw Data Group 1",
  "EXTRACTED_FIELDS_RFIDG2": "RFID Raw Data Group 2",
  "EXTRACTED_FIELDS_RFIDG3": "RFID Raw Data Group 3",
  "EXTRACTED_FIELDS_RFIDG15": "RFID Raw Data Group 4",
  "EXTRACTED_FIELDS_RFIDSOD": "RFID Raw Data Group 5",
  "EXTRACTED_FIELDS_PortraitPhoto": "Extracted Portrait Photo",
  "EXTRACTED_FIELDS_Title": "Title",
  "EXTRACTED_FIELDS_IssueDate2": "Second Issue Date",
  "EXTRACTED_FIELDS_ExpiryDate2": "Second Expiry Date",
  "EXTRACTED_FIELDS_LicenseCategory2": "Second License Category",
  "EXTRACTED_FIELDS_IssueDate3": "Third Issue Date",
  "EXTRACTED_FIELDS_ExpiryDate3": "Third Expiry Date",
  "EXTRACTED_FIELDS_LicenseCategory3": "Third License Category",
  "EXTRACTED_FIELDS_IssueDate4": "Fourth Issue Date",
  "EXTRACTED_FIELDS_ExpiryDate4": "Fourth Expiry Date",
  "EXTRACTED_FIELDS_LicenseCategory4": "Fourth License Category",
  "EXTRACTED_FIELDS_MRZCode1": "MRZ Code 1",
  "EXTRACTED_FIELDS_MRZCode2": "MRZ Code 2",
  "EXTRACTED_FIELDS_MRZStandardType": "MRZ Standard Type",
  "EXTRACTED_FIELDS_AddressStreetSuffix": "Street Suffix",
  "EXTRACTED_FIELDS_AddressStreetType": "Street Type",
  "EXTRACTED_FIELDS_AddressUnitNumber": "Address Unit Number",
  "EXTRACTED_FIELDS_LicenseNumber": "License Number",
  "EXTRACTED_FIELDS_AddressStateCode": "State Code",
  "EXTRACTED_FIELDS_AddressStreetTypeAbbreviation": "Street Abbreviation",
  "EXTRACTED_FIELDS_AddressUnitType": "Address Unit Type",
  "EXTRACTED_FIELDS_AddressDeliveryPointIdentifier": "Delivery Point Identifier",
  "EXTRACTED_FIELDS_AgeCategory": "Age Category",
  "EXTRACTED_FIELDS_ChildernCount": "Number of Children",
  "EXTRACTED_FIELDS_EntryMode": "Entry Mode",
  "EXTRACTED_FIELDS_VAFNumber": "VAF Number",
  "EXTRACTED_FIELDS_AddressLine5": "Address Line 5",
  "EXTRACTED_FIELDS_RFIDPortraitPhoto": "RFID Portrait Photo",
  "EXTRACTED_FIELDS_RefAddressLine5": "Reference Address Line 5",
  "EXTRACTED_FIELDS_RefAddressStateCode": "Reference Address State",
  "EXTRACTED_FIELDS_RefAddressStreetType": "Reference Address Street Type",
  "EXTRACTED_FIELDS_RefAddressStreetTypeAbbreviation": "Reference Address Street Type Abbreviation",
  "EXTRACTED_FIELDS_RefAddressStreetSuffix": "Reference Address Street Suffix",
  "EXTRACTED_FIELDS_RefAddressUnitNumber": "Reference Address Unit Number",
  "EXTRACTED_FIELDS_RefAddressUnitType": "Reference Address Unit Type",
  "EXTRACTED_FIELDS_RefAddressPostcodeType": "Reference Address Postcode Type",
  "EXTRACTED_FIELDS_RefAddressDeliveryPointIdentifier": "Reference Address Delivery Point Identifier",
  "EXTRACTED_FIELDS_RefAddressPOBoxNumber": "Reference Address PO Box Number",
  "EXTRACTED_FIELDS_RefAddressDependentLocality": "Reference Address Dependant Locality",
  "EXTRACTED_FIELDS_RefAddressDoubleDependentLocality": "Reference Address Double Dependant Locality",
  "EXTRACTED_FIELDS_RefAddressThoroughfare": "Reference Address Thoroughfare",
  "EXTRACTED_FIELDS_RefAddressThoroughfareDesc": "Reference Address Thoroughfare Description",
  "EXTRACTED_FIELDS_RefAddressDependentThoroughfare": "Reference Address Dependant Thoroughfare",
  "EXTRACTED_FIELDS_RefAddressDependentThoroughfareDesc": "Reference Address Dependent Thoroughfare Description",
  "EXTRACTED_FIELDS_RefAddressSubBuildingNumber": "Reference Address Sub Building Number",
  "EXTRACTED_FIELDS_AddressSubBuildingNumber": "Sub Building Number",
  "EXTRACTED_FIELDS_AddressSubBuildingName": "Sub Building Name",
  "EXTRACTED_FIELDS_AddressPostCodeType": "Postcode Type",
  "EXTRACTED_FIELDS_IssuingAuthorityType": "Issuing Authority Type",
  "EXTRACTED_FIELDS_Signature": "Signature",
  "EXTRACTED_FIELDS_Hologram": "Hologram",
  "EXTRACTED_FIELDS_CardNumber": "Card Number",
  "EXTRACTED_FIELDS_MiddleNameInitial": "Middle Name Initial",
  "EXTRACTED_FIELDS_PermitNumber": "Permit Number",
  "EXTRACTED_FIELDS_ReferenceNumber": "Reference Number",
  "EXTRACTED_FIELDS_CustomerNumber": "Customer Number",
  "EXTRACTED_FIELDS_BOSNumber": "BOS Number",
  "EXTRACTED_FIELDS_StudentID": "Student Identification Number",
  "EXTRACTED_FIELDS_MembershipNumber": "Membership Number",
  "EXTRACTED_FIELDS_LicenseType": "License Type",
  "EXTRACTED_FIELDS_LicenseType2": "License Type 2",
  "EXTRACTED_FIELDS_LicenseType3": "License Type 3",
  "EXTRACTED_FIELDS_LicenseType4": "License Type 4",
  "EXTRACTED_FIELDS_DocumentTypeCode": "Document Type Code",
  "EXTRACTED_FIELDS_MRZDocumentNumberCheckDigit": "MRZ CheckDigit",
  "EXTRACTED_FIELDS_MRZBirthDateCheckDigit": "MRZ Birth Date Check Digit",
  "EXTRACTED_FIELDS_MRZExpiryDateCheckDigit": "MRZ Expiry Date Check Digit",
  "EXTRACTED_FIELDS_MRZPersonalNumberCheckDigit": "MRZ Personal Number Check Digit",
  "EXTRACTED_FIELDS_MRZCompositeCheckDigit": "MRZ Composite Check Digit",
  "EXTRACTED_FIELDS_SecondaryPortraitPhoto": "Secondary Portrait Photo",
  "EXTRACTED_FIELDS_Fingerprint": "Fingerprint",
  "EXTRACTED_FIELDS_VersionNumber": "Version Number",
  "EXTRACTED_FIELDS_Conditions": "Conditions",
  "EXTRACTED_FIELDS_NickName": "Nickname",
  "EXTRACTED_FIELDS_AddressApartmentNumber": "Apartment Number",
  "EXTRACTED_FIELDS_AddressFloorNumber": "Floor Number",
  "EXTRACTED_FIELDS_FirstNameLocal": "First Name Local",
  "EXTRACTED_FIELDS_LastNameLocal": "Last Name Local",
  "EXTRACTED_FIELDS_FullNameLocal": "Full Name Local",
  "EXTRACTED_FIELDS_BirthPlaceLocal": "Birth Place Local",
  "EXTRACTED_FIELDS_IssuingAuthorityLocal": "Issuing Authority Local",
  "EXTRACTED_FIELDS_MotherNameLocal": "Mother Name Local",
  "EXTRACTED_FIELDS_FatherNameLocal": "Father Name Local",
  "EXTRACTED_FIELDS_AddressFullLocal": "Address Full Local",
  "EXTRACTED_FIELDS_MiddleNameLocal": "Middle Name Local",
  "EXTRACTED_FIELDS_AddressLine1Local": "Address Line1 Local",
  "EXTRACTED_FIELDS_AddressLine2Local": "Address Line2 Local",
  "EXTRACTED_FIELDS_AddressLine3Local": "Address Line3 Local",
  "EXTRACTED_FIELDS_IndRefNumber1": "Individual Reference Number 1",
  "EXTRACTED_FIELDS_IndRefNumber2": "Individual Reference Number 2",
  "EXTRACTED_FIELDS_IndRefNumber3": "Individual Reference Number 3",
  "EXTRACTED_FIELDS_IndRefNumber4": "Individual Reference Number 4",
  "EXTRACTED_FIELDS_IndRefNumber5": "Individual Reference Number 5",
  "EXTRACTED_FIELDS_Name1": "Name 1",
  "EXTRACTED_FIELDS_Name2": "Name 2",
  "EXTRACTED_FIELDS_Name3": "Name 3",
  "EXTRACTED_FIELDS_Name4": "Name 4",
  "EXTRACTED_FIELDS_Name5": "Name 5",
  "EXTRACTED_FIELDS_RECIPIENT_NAME_1": "Recipient Name 1",
  "EXTRACTED_FIELDS_RECIPIENT_NAME_2": "Recipient Name 2",
  "EXTRACTED_FIELDS_RECIPIENT_NAME_3": "Recipient Name 3",
  "EXTRACTED_FIELDS_RECIPIENT_NAME_4": "Recipient Name 4",
  "EXTRACTED_FIELDS_RECIPIENT_ADDRESS_FULL": "Recipient Address Full",
  "EXTRACTED_FIELDS_IBAN": "IBAN Account Number",
  "EXTRACTED_FIELDS_ACCOUNT_NUM": "Account Number",
  "EXTRACTED_FIELDS_ISSUER": "Issuer",
  "EXTRACTED_FIELDS_RECIPIENT_ADDRESS_CITY": "Recipient Address City",
  "EXTRACTED_FIELDS_RECIPIENT_ADDRESS_POST_CODE": "Recipient Address Post Code",
  "EXTRACTED_FIELDS_DAY": "Day",
  "EXTRACTED_FIELDS_MONTH": "Month",
  "EXTRACTED_FIELDS_YEAR": "Year",
  "EXTRACTED_FIELDS_OPTIONAL_VALUE_1": "Optional Value 1",
  "EXTRACTED_FIELDS_OPTIONAL_VALUE_2": "Optional Value 2",
  "EXTRACTED_FIELDS_OPTIONAL_VALUE_3": "Optional Value 3",
  "EXTRACTED_FIELDS_OPTIONAL_VALUE_4": "Optional Value 4",
  "EXTRACTED_FIELDS_ISSUING_STATE_NAME": "Issuing State Name",
  "EXTRACTED_FIELDS_FRONT_DOCUMENT_TYPE_ID": "Frontside Document Type Id",
  "EXTRACTED_FIELDS_BACK_DOCUMENT_TYPE_ID": "Backside Document Type Id",
  "HASNOCAMERA_TITLE": "Oops, we could not recognise a camera on your device!",
  "HASNOCAMERA_DESCRIPTION": "It looks like your device does not have a camera, please retry on a different device that has a working camera so you are able to carry out all the steps required.",
  "EXTRACTED_FIELDS_COVIDPASSCROSSCHECKRESULT": "Covid Type Id",
  "USER_INPUT_FIRST_NAME": "First Name",
  "USER_INPUT_MIDDLE_NAME": "Middle Name",
  "USER_INPUT_LAST_NAME": "Last Name",
  "USER_INPUT_DOB": "Date of Birth",
  "USER_INPUT_HOUSE_NAME_NUMBER": "House Name/Number*",
  "USER_INPUT_STREET_NAME": "Street Name*",
  "USER_INPUT_TOWN": "Town*",
  "USER_INPUT_POSTAL_CODE": "Postal Code*",
  "USER_INPUT_HOUSE_NAME_NUMBER_EXAMPLE": "e.g. House/35",
  "USER_INPUT_STREET_NAME_EXAMPLE": "e.g. Test Street",
  "USER_INPUT_TOWN_EXAMPLE": "e.g. Somewhere",
  "USER_INPUT_POSTAL_CODE_EXAMPLE": "e.g. CH496 (no spaces)",
  "SYSTEM_NOT_ABLE": "System was not able to scan the document",
  "TRY_AGAIN": "Try again",
  "HINTS_DISABLED_HEADER": "Hints are turned off in manual mode",
  "HINTS_DISABLED_DESCRIPTION": "If you want to turn on hints for taking photo, switch to AUTO CAPTURE",
  "YOU_HAVE": "You have",
  "PICTURE_VERIFYING": "Verifying...",
  "HOW_TO_TAKE_PHOTO_CORRECTLY": "How to take a photo correctly",
}